<template>
  <chart-container :title="title">
    <apexchart
      type="pie"
      :height="computedOptions.height"
      :options="computedOptions"
      :series="computedSeries"
    />
  </chart-container>
</template>

<script>
import _merge from "lodash.merge";

import ChartContainer from "@/components/dashboard/ChartContainer.vue";
import { ApexBaseChartOptions } from "@/commons/chart-commons.js";

export default {
  components: {
    ChartContainer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  computed: {
    computedOptions() {
      const localOptions = {
        height: this.computedHeigth,
        chart: {
          events: {
            dataPointSelection: (event, chartContext, config) => {
              if (config) {
                this.$emit("filter", [{
                  source: "chart",
                  title: this.title,
                  text: config.w.config.labels[config.dataPointIndex],
                }]);
              }
            },
          },
        },
      };
      return _merge(
        {},
        ApexBaseChartOptions,
        localOptions,
        this.options.plotOptions
      );
    },
    computedSeries() {
      return this.options.series;
    },
    computedHeigth() {
      switch (this.height) {
        case 200:
          return 215;
        case 300:
          return 314.6;
        case 340:
          return 354;
        default:
          return (this.height || ApexBaseChartOptions.height) + 15;
      }
    },
  },
};
</script>